import * as Tabs from '@radix-ui/react-tabs'
import { cn } from '@/lib/utils'
import type { TimePeriod } from '@/types/dashboard'

interface TimePeriodToggleProps {
  value: TimePeriod
  onChange: (period: TimePeriod) => void
}

const periods: { value: TimePeriod; label: string }[] = [
  { value: '24h', label: '24h' },
  { value: '7d', label: '7d' },
  { value: '30d', label: '30d' },
  { value: 'all', label: 'All' },
]

export function TimePeriodToggle({ value, onChange }: TimePeriodToggleProps) {
  return (
    <Tabs.Root value={value} onValueChange={(v) => onChange(v as TimePeriod)}>
      <Tabs.List className="inline-flex items-center gap-1 rounded-lg bg-muted p-1">
        {periods.map((p) => (
          <Tabs.Trigger
            key={p.value}
            value={p.value}
            className={cn(
              'rounded-md px-3 py-1 text-xs font-medium transition-colors',
              'text-muted-foreground hover:text-foreground',
              'data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm'
            )}
          >
            {p.label}
          </Tabs.Trigger>
        ))}
      </Tabs.List>
    </Tabs.Root>
  )
}
